import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AnalyticsService } from '../../../services/analytics.service';
import { VendasPorDiaSemanaApi } from '../../../models/analytics.model';

@Component({
  selector: 'app-vendas-por-dia-semana-chart',
  standalone: true,
  imports: [CommonModule, DecimalPipe, CurrencyPipe],
  templateUrl: './vendas-por-dia-semana-chart.component.html',
  styleUrls: ['./vendas-por-dia-semana-chart.component.css']
})
export class VendasPorDiaSemanaChartComponent implements OnInit {
  dados: VendasPorDiaSemanaApi[] = [];
  isLoading = true;
  hasError = false;

  constructor(
    private analyticsService: AnalyticsService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.carregarDados();
  }

  carregarDados(): void {
    this.isLoading = true;
    this.hasError = false;

    this.analyticsService.getMediaVendasPorDiaSemana().subscribe({
      next: (data) => {
        this.dados = Array.isArray(data)
          ? [...data].sort((a, b) => (a.numDiaSemana ?? 0) - (b.numDiaSemana ?? 0))
          : [];
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.isLoading = false;
        this.hasError = true;
        this.toastr.error('Erro ao carregar o relatório de vendas por dia da semana.');
        this.cdr.detectChanges();
      }
    });
  }

  get maiorPercQuantidade(): number {
    return Math.max(...this.dados.map(item => Number(item.percQuantidade ?? 0)), 0);
  }

  larguraBarraQuantidade(percentual: number): number {
    const maior = this.maiorPercQuantidade || 100;
    return Math.max(8, (Number(percentual ?? 0) / maior) * 100);
  }
}